import * as React from "react";
// mui components
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import { useTheme } from "@mui/material/styles";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function GeneralTab({
  tab,
  tabPanel,
  sx,
  tabSx,
  indicatorColor,
}: {
  tab: Array<any>;
  tabPanel: Array<any>;
  sx?: {};
  tabSx?: {};
  indicatorColor?: "primary" | "secondary" | undefined;
}) {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  //
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


  return (
    <Box>
      <Tabs
        sx={sx}
        value={value}
        onChange={handleChange}
        indicatorColor={indicatorColor}
        textColor="inherit"
        variant="scrollable"
        aria-label="full width tabs example"
      >
        {tab.map((item, index) => (
          <Tab
            sx={{
              ...tabSx,
              textTransform: "capitalize",
              fontWeight: 700,
              fontSize: 16,
            }}
            key={`${index}-tab`}
            label={item}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
      <div
      >
        {tabPanel.map((item, index) => (
          <TabPanel
            key={`${index}-tabPanel`}
            value={value}
            index={index}
            dir={theme.direction}
          >
            {item}
          </TabPanel>
        ))}
      </div>
    </Box>
  );
}
